const variants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK: 'dark',
  LINK: 'link',
  WARNING: 'warning',
  SUCCESS: 'success',
};

export default variants;
